import { Currency } from './payment';

export type Subject = 'CHINESE' | 'MATH' | 'ENGLISH';

export interface OrderPayload {
  skuProductId: string; // 课包 ID
  quantity: number; // 数量
  currency: Currency; // 币种，如 "USD"
  activityId: string; // 活动 ID
  subject: Subject; // 课程科目，如 "CHINESE"
  orderData?: Record<string, any>; // 自由结构的 JSON 数据
}

export interface ActivityDetailReq {
  activityId: string;
  subject: string;
}

export enum ActivityType {
  NOT_PAID = 'NOT_PAID', // 未付费
  NEW_SIGN = 'NEW_SIGN', // 新签
  IN_STUDY = 'IN_STUDY', // 在读
  RENEWAL = 'RENEWAL', // 续费
}

export const activityStudentType = {
  [ActivityType.IN_STUDY]: '在读',
  [ActivityType.RENEWAL]: '续费',
  [ActivityType.NOT_PAID]: '未付费',
  [ActivityType.NEW_SIGN]: '新签',
};

export type ActivityTagType = 'MostPopular' | 'Advanced' | 'Hot';

export interface ActivityResult<T> {
  content: T;
}

export interface RenewalEntriesType {
  activityId: string; // 活动Id
  activityZhName: string; // 活动中文名称
  activityEnName: string; // 活动英文名称
  subjects: Subject | Subject[]; // 活动中可使用的科目
  activityType: ActivityType; // 活动类型
  mobileZhUrl: string; // banner url
  mobileEnUrl: string; // banner url
  webZhUrl: string; // banner url
  webEnUrl: string; // banner url
  startTime: string;
  expireTime: string;
  activityStatus: string;
}

export interface NormalEntryType {
  activityId: string; // 活动Id
  activityZhName: string; // 活动中文名称
  activityEnName: string; // 活动英文名称
  subjects: Subject | Subject[]; // 活动中可使用的科目
  activityType: ActivityType; // 活动类型
  startTime: string;
  expireTime: string;
  activityStatus: string;
}

export interface CourseCreditsEntryType {
  renewalEntries: RenewalEntriesType[];
  courseCreditsEntries: {
    chinese?: RenewalEntriesType;
    math?: RenewalEntriesType;
    english?: RenewalEntriesType;
  };
  studentType: any;
}

export interface HomeEntryType {
  normalEntry?: NormalEntryType;
  renewalEntries?: RenewalEntriesType[];
  studentType?: any;
}

interface TeacherInfo {
  uuid: string;
  teacherNameZh: string;
  teacherNameEn: string;
  teacherImage: string;
}

interface AcademicSummaryItem {
  totalCompleted?: number; //累计完课
  totalLearningHours?: number; //累计上课时长
  trophiesEarned?: number; //课堂奖杯数
  homeworkSubmitNum: number; //提交作业次数
  homeworkCorrectAnswersNum?: number; //正确答题数量（作业）
  homeworkCorrectRate?: number; //作业答题正确率
  totalSpeekTime?: number; //累计开口时长
  avgParticipationRateInClass?: number; //课中互动题参与率均值
  avgAccuracyRateInClass?: number; //课堂互动题正确率均值
  totalEssaysCompletedNum?: number; //累计完成作文数量
  avgEssayScore?: number; //作文平均得分（星级）
}

interface Price {
  value: number;
  currency: Currency;
}

export interface Sku {
  uuid: string;
  packageZhName: string;
  packageEnName: string;
  price: Price;
  originalPrice: Price;
  discountRate: { currency: Currency; percent: number };
  standardLessons: number;
  giftLessonsNumber: number;
  paymentIn24hBonusLessons: number;
  activitySkuTag: string;
  courseCredits: number;
  skuProductId: string;
}

export interface ActivityData {
  uuid: string;
  activityId: string;
  activityEnName: string;
  activityZhName: string;
  activityEnDescription: string;
  activityZhDescription: string;
  activityType: ActivityType;
  activityTag: string;
  expireTime: string;
  teacherInfo: TeacherInfo;
  academicSummary: AcademicSummaryItem;
  skuList: Sku[];
  activityZhRules: string;
  activityEnRules: string;
  activityStatus: 'ON' | 'OFF' | 'DELETE';
  startTime: string;
}

export enum LevelType {
  PRE_VIEW = 'PRE_VIEW',
  VIEW = 'VIEW',
  NEXT_VIEW = 'NEXT_VIEW',
  NOW = 'NOW',
}

export interface Level {
  zone: string;
  position: number;
  type: string;
  name?: string;
  height?: number;
}

type learningSummaryItemValue = {
  min: number;
  max: number;
};
export interface CardDetailType {
  learningGoalEn: string;
  learningGoalZh: string;
  levels: Level[];
  learningSummary: {
    chinese?: {
      characters: learningSummaryItemValue;
      words: learningSummaryItemValue;
      sentences: learningSummaryItemValue;
      rhymesAndPoems: learningSummaryItemValue;
      texts: learningSummaryItemValue;
      writingPractice: learningSummaryItemValue;
    };
    math?: {
      number: learningSummaryItemValue;
      geometry: learningSummaryItemValue;
      problem: learningSummaryItemValue;
      reasoning: learningSummaryItemValue;
      probability: learningSummaryItemValue;
    };
    ength?: {
      genre: learningSummaryItemValue;
      vocabulary: learningSummaryItemValue;
      extendingVocabulary: learningSummaryItemValue;
      grammar: learningSummaryItemValue;
      ReadingStrategy: learningSummaryItemValue;
      writingTraits: learningSummaryItemValue;
      languageGems: learningSummaryItemValue;
    };
  };
}

export interface SubjectsRep {
  cuRemaining: { chinese: number; math: number; english: number };
  subjects: string[];
  studentType: any;
}
